import { render, staticRenderFns } from "./customerCases.vue?vue&type=template&id=7c81c844&scoped=true"
import script from "./customerCases.vue?vue&type=script&lang=js"
export * from "./customerCases.vue?vue&type=script&lang=js"
import style0 from "./customerCases.vue?vue&type=style&index=0&id=7c81c844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81c844",
  null
  
)

export default component.exports